// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1GUQj","vLegacy":"SelectSecondary_vLegacy__3ney7","error":"SelectSecondary_error__3WxUk","disabled":"SelectSecondary_disabled__2yJPE"};